<template>
  <div class="container">
    <div class="header">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="用户管理" name="first"></el-tab-pane>
        <el-tab-pane label="配置管理" name="second"></el-tab-pane>
      </el-tabs> -->
      <div
        style="
          display: flex;
          justify-content: space-evenly;
          width: 100%;
          height: 100%;
        "
      >
        <div
          v-for="tab in tabs"
          :key="tab.id"
          :class="[selectedTabId === tab.id ? 'tab-active' : 'tab-inactive']"
          @click="tabClick(tab)"
        >
          <p>{{ tab.templateTypeName }}</p>
          <span></span>
        </div>
      </div>
    </div>
    <div v-if="selectedTabId === 0" class="start-div">
      <div class="content-div">
        <div
          class="background"
          :style="{
            background: `linear-gradient(180deg,${startInfo.startColorBegin}, ${startInfo.startColorEnd})`,
          }"
        >
          <div class="foreground">
            <div
              class="hidden-title"
              style="
                font-size: 24px;
                font-weight: 600;
                max-width: 280px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
              :style="{ color: startInfo.startThemeColor }"
            >
              {{ startInfo.title }}88
            </div>
            <div style="margin-top: 120px">
              <input
                placeholder-class="input-placeholder"
                type="text"
                v-model="startInfo.desc"
                placeholder="输入内容..."
                style="
                  border: 1px dashed #ffffff;
                  text-align: center;
                  min-width: 160px;
                  max-width: 440px;
                  height: 34px;
                  font-size: 14px;
                  background: none;
                  font-weight: 400;
                "
                :style="{
                  width: startInfo.descWidth,
                  color: startInfo.startThemeColor,
                }"
              />
              <div
                class="hidden-start-desc"
                style="
                  opacity: 0;
                  position: fixed;
                  top: 0;
                  z-index: -1;
                  font-size: 14px;
                  font-weight: 400;
                "
                :style="{ color: startInfo.startThemeColor }"
              >
                {{ startInfo.desc }}
              </div>
            </div>
            <button
              v-if="selectedTabId === 0"
              class="create-button"
              :style="{ background: startInfo.btnBg }"
            >
              {{ startInfo.btnText }}
            </button>
          </div>
        </div>
      </div>
      <div class="color-selection">
        <div style="font-size: 15px; font-weight: 600">颜色：</div>
        <div class="color-options">
          <div
            v-for="(item, index) in colors"
            :key="index"
            @click="selectStartColor(index)"
            class="color-option"
          >
            <div
              class="color-rectangle"
              :style="{ backgroundColor: item.color }"
            >
              <img
                v-show="startInfo.index === index"
                src="@/assets/images/duihao.svg"
                alt=""
                class="select-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="end-div">
      <div class="content-div">
        <div
          class="background"
          :style="{
            background: `linear-gradient(180deg,${endInfo.endColorBegin}, ${endInfo.endColorEnd})`,
          }"
        >
          <div class="foreground">
            <div style="margin-top: 20px">
              <input
                placeholder-class="input-placeholder"
                type="text"
                v-model="this.endInfo.title"
                placeholder="输入内容..."
                style="
                  border: 1px dashed #ffffff;
                  text-align: center;
                  min-width: 104px;
                  max-width: 260px;
                  height: 33px;
                  font-size: 24px;
                  font-weight: 600;
                "
                :style="{
                  width: this.endInfo.titleWidth,
                  color: this.endInfo.endThemeColor,
                }"
              />
              <div
                class="hidden-title"
                style="
                  opacity: 0;
                  position: fixed;
                  top: 0;
                  z-index: -1;
                  font-size: 48px;
                  font-weight: 600;
                "
                :style="{ color: endInfo.endThemeColor }"
              >
                {{ this.endInfo.title }}
              </div>
            </div>
            <div style="margin-top: 120px">
              <input
                placeholder-class="input-placeholder"
                type="text"
                v-model="this.endInfo.desc"
                placeholder="输入内容..."
                style="
                  border: 1px dashed #ffffff;
                  text-align: center;
                  min-width: 160px;
                  max-width: 540px;
                  height: 33px;
                  font-size: 14px;
                  font-weight: 400;
                  background: none;
                "
                :style="{
                  width: endInfo.descWidth,
                  color: endInfo.endThemeColor,
                }"
              />
              <div
                class="hidden-end-desc"
                style="
                  opacity: 0;
                  position: fixed;
                  top: 0;
                  z-index: -1;
                  font-size: 28px;
                  font-weight: 400;
                "
                :style="{ color: endInfo.endThemeColor }"
              >
                {{ endInfo.desc }}
              </div>
            </div>
            <button class="create-button" style="opacity: 0"></button>
          </div>
        </div>
      </div>
      <div class="color-selection">
        <div style="font-size: 15px; font-weight: 600">颜色：</div>
        <div class="color-options">
          <div
            v-for="(item, index) in colors"
            :key="index"
            @click="selectEndColor(index)"
            class="color-option"
          >
            <div
              class="color-rectangle"
              :style="{ backgroundColor: item.color }"
            >
              <img
                v-show="endInfo.index === index"
                src="@/assets/images/duihao.svg"
                alt=""
                class="select-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-div">
      <div class="cancel" @click="cancel">取消</div>
      <div class="save" @click="save">保存</div>
    </div>
    <div class="safe-div"></div>
    <!-- <uploadImage :show="this.showUpload" :maxCount="1" :images='0' @upload-close="this.showUpload = false"
                     @upload-success="handleUploadComplete"></uploadImage> -->
  </div>
</template>

<script>
export default {
  props: {
    dataObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      colors: [
        {
          color: "#1D4AC3",
          btnBg: "#FFA24F",
          littleImage:
            "https://ossfastmake.mustke.com/qrCode/tupian/1737535407358.png",
          startColor: "#6728E3",
          endColor: "#1D4AC3",
          themeColor: "#FFFFFF",
          textColor: "#FFFFFF",
        },
        {
          color: "#B71211",
          btnBg: "#FFA24F",
          littleImage:
            "https://ossfastmake.mustke.com/qrCode/tupian/1737535407358.png",
          startColor: "#B71211",
          endColor: "#A4246A",
          themeColor: "#FFFFFF",
          textColor: "#FFFFFF",
        },
        {
          color: "#F7745B",
          btnBg: "#FFA24F",
          littleImage:
            "https://ossfastmake.mustke.com/qrCode/tupian/1737535407358.png",
          startColor: "#F7745B",
          endColor: "#D9006A",
          themeColor: "#FFFFFF",
          textColor: "#FFFFFF",
        },
        {
          color: "#FDAC01",
          btnBg: "#FFA24F",
          littleImage:
            "https://ossfastmake.mustke.com/qrCode/tupian/1737535407358.png",
          startColor: "#FDAC01",
          endColor: "#D92900",
          themeColor: "#FFFFFF",
          textColor: "#FFFFFF",
        },
        {
          color: "#47B25E",
          btnBg: "#FFA24F",
          littleImage:
            "https://ossfastmake.mustke.com/qrCode/tupian/1737535407358.png",
          startColor: "#47B25E",
          endColor: "#47A5B2",
          themeColor: "#FFFFFF",
          textColor: "#FFFFFF",
        },
        {
          color: "#0BCBAE",
          btnBg: "#FFA24F",
          littleImage:
            "https://ossfastmake.mustke.com/qrCode/tupian/1737535407358.png",
          startColor: "#0BCBAE",
          endColor: "#477CB2",
          themeColor: "#FFFFFF",
          textColor: "#FFFFFF",
        },
        {
          color: "#EB6300",
          btnBg: "#FFA24F",
          littleImage:
            "https://ossfastmake.mustke.com/qrCode/tupian/1737535407358.png",
          startColor: "#EB6300",
          endColor: "#F50000",
          themeColor: "#FFFFFF",
          textColor: "#FFFFFF",
        },
        {
          color: "#FFFFFF",
          btnBg: "#3A60FF",
          littleImage:
            "https://ossfastmake.mustke.com/qrCode/tupian/1752823971187.svg",
          startColor: "#FFFFFF",
          endColor: "#FFFFFF",
          themeColor: "#2B2F36",
          textColor: "#666666",
        },
        {
          color: "#1E1E1E",
          btnBg: "#FFA24F",
          littleImage:
            "https://ossfastmake.mustke.com/qrCode/tupian/1737535407358.png",
          startColor: "#300C0C",
          endColor: "#000000",
          themeColor: "#FFFFFF",
          textColor: "#FFFFFF",
        },
      ],
      selectedIndex: 6, // 默认选中的颜色索引
      tabs: [
        {
          id: 0,
          templateTypeName: "问卷开始",
        },
        {
          id: 1,
          templateTypeName: "问卷结束",
        },
      ],
      startInfo: {
        image: "",
        title: "问卷标题",
        desc: "感谢您的参与",
        btnText: "开始答题",
        descWidth: "",
        bg: "",
        index: 0,
        btnBg: "",
        startLittleImg: "",
      },
      endInfo: {
        image: "",
        title: "问卷已结束",
        desc: "感谢您的参与",
        titleWidth: "",
        descWidth: "",
        bg: "",
        index: 0,
        btnBg: "",
        endLittleImg: "",
      },
      selectedTabId: 0,
      showUpload: false,
      startLittleBoole: true,
      endLittleBoole: true,
      activeName: "second",
    };
  },
  methods: {
    tabClick(e) {
      // console.log(this.activeTab,e);
      this.selectedTabId = e.id;
    },
    handleInputStartDesc(e) {
      nextTick(() => {
        // this.descValue = e.detail.value
        const query = uni.createSelectorQuery();
        query.select(".hidden-start-desc").boundingClientRect();
        query.selectdivport().scrollOffset();
        query.exec((res) => {
          this.startInfo.descWidth = (res[0].width + 40) * 2 + "px";
        });
      });
    },
    handleInputEndDesc(e) {
      nextTick(() => {
        const query = uni.createSelectorQuery();
        query.select(".hidden-end-desc").boundingClientRect();
        query.selectdivport().scrollOffset();
        query.exec((res) => {
          this.endInfo.descWidth = (res[0].width + 40) * 2 + "px";
        });
      });
    },
    selectStartColor(index) {
      this.startInfo.image = this.colors[index].url;
      this.startInfo.bg = this.colors[index].color;
      this.startInfo.index = index;
      this.startInfo.btnBg = this.colors[index].btnBg;
      this.startInfo.startColorBegin = this.colors[index].startColor;
      this.startInfo.startColorEnd = this.colors[index].endColor;
      this.startInfo.startThemeColor = this.colors[index].themeColor;
      this.startInfo.startTextColor = this.colors[index].textColor;
      this.startInfo.startLittleImg = this.colors[index].littleImage;
    },
    selectEndColor(index) {
      this.endInfo.image = this.colors[index].url;
      this.endInfo.bg = this.colors[index].color;
      this.endInfo.index = index;
      this.endInfo.btnBg = this.colors[index].btnBg;
      this.endInfo.endColorBegin = this.colors[index].startColor;
      this.endInfo.endColorEnd = this.colors[index].endColor;
      this.endInfo.endThemeColor = this.colors[index].themeColor;
      this.endInfo.endThemeColor = this.colors[index].textColor;
      this.endInfo.endLittleImg = this.colors[index].littleImage;

      console.log(this.endInfo);
    },
    handleInputTitle(e) {
      nextTick(() => {});
    },
    cancel() {
      this.$emit("cancel");
    },
    save() {
      // 保存的逻辑
      console.log("保存");
      const data = {
        startLanguage: this.startInfo.desc, // 问卷开始语
        endLanguage: this.endInfo.desc, // 问卷结束语
        endImg: this.endInfo.image, // 问卷结束图片
        startImg: this.startInfo.image, // 问卷开始图片
        startSubtitle: this.startInfo.title, // 问卷开始小标题
        startButtonText: this.startInfo.btnText, // 问卷开始按钮文本
        startButtonColor: this.startInfo.btnBg, // 问卷开始按钮颜色
        startColor: this.startInfo.bg, // 问卷开始主题颜色
        endColor: this.endInfo.bg, // 问卷结束主题颜色
        endSubtitle: this.endInfo.title, // 问卷结束小标题
        startLittleImg: this.startInfo.startLittleImg, // 问卷开始小图片
        endLittleImg: this.endInfo.endLittleImg, // 问卷结束小图片
        ifFrontPage: "1", // 是否为首页
        startColorBegin: this.startInfo.startColorBegin,
        startColorEnd: this.startInfo.startColorEnd,
        startThemeColor: this.startInfo.startThemeColor,
        startTextColor: this.startInfo.startTextColor,
        endColorBegin: this.endInfo.endColorBegin,
        endColorEnd: this.endInfo.endColorEnd,
        endThemeColor: this.endInfo.endThemeColor,
        endTextColor: this.endInfo.endTextColor,
      };
      this.$emit("start-end", data);
    },
  },
  watch: {
    dataObj: {
      handler(newVal, oldVal) {
        console.log("90909090909090909", newVal, oldVal);

        console.log(
          "7898797897898797978987",
          newVal.startSubtitle === "",
          newVal.startSubtitle === null,
          newVal.startSubtitle === undefined,
        );

        this.startInfo.title = newVal.startSubtitle
          ? newVal.startSubtitle
          : newVal.questionnaireName === ""
          ? "问卷标题"
          : newVal.questionnaireName;
        this.startInfo.desc = newVal.startLanguage
          ? newVal.startLanguage
          : "感谢您的参与";
        this.startInfo.btnText = newVal.startButtonText
          ? newVal.startButtonText
          : "开始答题";
        this.startInfo.btnColor = newVal.startButtonColor;
        this.startInfo.bg =
          newVal.startColor === "" || newVal.startColor === null
            ? "#B71211"
            : newVal.startColor;
        this.startInfo.image =
          newVal.startImg === "" || newVal.startImg === null
            ? "https://ossfastmake.mustke.com/qrCode/tupian/1747900224510.png"
            : newVal.startImg;
        this.startInfo.index =
          newVal.startColor === "" || newVal.startColor === null
            ? 0
            : this.colors.findIndex((item) => item.color === newVal.startColor);
        this.endInfo.title = newVal.endSubtitle
          ? newVal.endSubtitle
          : "问卷已结束";
        this.endInfo.desc = newVal.endLanguage
          ? newVal.endLanguage
          : "感谢您的参与";
        this.endInfo.bg =
          newVal.endColor === "" || newVal.endColor === null
            ? "#B71211"
            : newVal.endColor;
        this.endInfo.image =
          newVal.endImg === "" || newVal.endImg === null
            ? "https://ossfastmake.mustke.com/qrCode/tupian/1747900224510.png"
            : newVal.endImg;

        this.endInfo.index =
          newVal.endColor === "" || newVal.endColor === null
            ? 0
            : this.colors.findIndex((item) => item.color === newVal.endColor);
        this.startInfo.btnBg =
          newVal.startButtonColor === "" || newVal.startButtonColor === null
            ? "#FFA24F"
            : newVal.startButtonColor;
        this.startInfo.startLittleImg =
          newVal.startLittleImg === "" || newVal.startLittleImg === null
            ? "https://ossfastmake.mustke.com/qrCode/tupian/1749173759152.svg"
            : newVal.startLittleImg;
        this.endInfo.endLittleImg =
          newVal.endLittleImg === "" || newVal.endLittleImg === null
            ? "https://ossfastmake.mustke.com/qrCode/tupian/1749173759152.svg"
            : newVal.endLittleImg;

        this.startInfo.startColorBegin =
          newVal.startColorBegin === "" ||
          newVal.startColorBegin === null ||
          newVal.startColorBegin === undefined
            ? "#6728E3"
            : newVal.startColorBegin;
        this.startInfo.startColorEnd =
          newVal.startColorEnd === "" ||
          newVal.startColorEnd === null ||
          newVal.startColorEnd === undefined
            ? "#1D4AC3"
            : newVal.startColorEnd;
        this.startInfo.startThemeColor =
          newVal.startThemeColor === "" ||
          newVal.startThemeColor === null ||
          newVal.startThemeColor === undefined
            ? "#FFFFFF"
            : newVal.startThemeColor;
        this.startInfo.startTextColor =
          newVal.startTextColor === "" ||
          newVal.startTextColor === null ||
          newVal.startTextColor === undefined
            ? "#FFFFFF"
            : newVal.startTextColor;
        this.endInfo.endColorBegin =
          newVal.endColorBegin === "" ||
          newVal.endColorBegin === null ||
          newVal.endColorBegin === undefined
            ? "#6728E3"
            : newVal.endColorBegin;
        this.endInfo.endColorEnd =
          newVal.endColorEnd === "" ||
          newVal.endColorEnd === null ||
          newVal.endColorEnd === undefined
            ? "#1D4AC3"
            : newVal.endColorEnd;
        this.endInfo.endThemeColor =
          newVal.endThemeColor === "" ||
          newVal.endThemeColor === null ||
          newVal.endThemeColor === undefined
            ? "#FFFFFF"
            : newVal.endThemeColor;
        this.endInfo.endTextColor =
          newVal.endTextColor === "" ||
          newVal.endTextColor === null ||
          newVal.endTextColor === undefined
            ? "#FFFFFF"
            : newVal.endTextColor;

        console.log("pepepepepeppeep", this.startInfo, this.endInfo);

        if (
          this.startInfo.startLittleImg !=
          "https://ossfastmake.mustke.com/qrCode/tupian/1749173759152.svg"
        ) {
          this.startLittleBoole = false;
        }
        if (
          this.endInfo.endLittleImg !=
          "https://ossfastmake.mustke.com/qrCode/tupian/1749173759152.svg"
        ) {
          this.endLittleBoole = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
// import { nextTick, onMounted, reactive } from "vue";
// import { onLoad } from "@dcloudio/uni-app";

// const this = reactive({

//
// });

// onMounted(() => {});

// onLoad((option) => {
//   const data = JSON.parse(option.info);
//   console.log("datappppppppppppp", data);

//   console.log("e2e21e21e2e21qweqwewqewqewq", this.startInfo, this.endInfo);
// });

// function handleTabsChange(e) {
//   this.tabIndex = e.index;
// }

// function handleChangeCover() {
//   this.showUpload = true;
// }

// function handleUploadComplete(res) {
//   if (this.tabIndex === 0) {
//     this.startInfo.startLittleImg = res[0];
//     this.startLittleBoole = false;
//   } else {
//     this.endInfo.endLittleImg = res[0];
//     this.endLittleBoole = false;
//   }
// }
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.header {
  width: 100%;
  height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px 0 rgba(192, 192, 192, 0.5);
}

.content-div {
  height: 477px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.background {
  width: 300px;
  height: 477px;
  border-radius: 16px;
  position: relative;
}

.background-image {
  width: 100%;
  border-radius: 10px;
}

.image-div {
  width: 240px;
  height: 219px;
  border: 1px dashed #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.image-div image {
  width: 212px;
  height: 190px;
}

.image-div text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 32px;
  color: #bcbcbc;
  z-index: 2;
  margin-left: -20px;
  margin-top: 20px;
}

.foreground {
  position: absolute;
  top: 56%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
}

.create-button {
  margin-top: 50px;
  width: 246px;
  height: 43px;
  border-radius: 4px;
  font-weight: 600;
  text-align: center;
  color: #ffffff;
  line-height: 43px;
  font-size: 18px;
}

.color-selection {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #f8f8f8;
  margin-top: 60px;
}

.color-options {
  display: flex;
  margin-left: 8px;
}

.color-option {
  width: 27.5px;
  height: 27.5px;
  margin-right: 8px;
  border-radius: 4px;
  border: 2px solid #e7e7e7;
  overflow: hidden;
}

.color-rectangle {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.select-image {
  width: 28px;
  height: 20px;
}

.btn-div {
  /* width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  position: absolute;
  left: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 200;
  padding: 25px; */
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
}

.cancel {
  /* flex: 1;
  height: 66px;
  line-height: 66px;
  border-radius: 66px;
  border: 1px solid #3a60ff;
  background: #ffffff;
  font-size: 34px;
  color: #3a60ff;
  font-weight: 600;
  text-align: center; */
  width: 134px;
  height: 46.5px;
  line-height: 46.5px;
  color: #3a60ff;
  background-color: #ffffff;
  border: 1px solid #3a60ff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 25px;
  text-align: center;
  cursor: pointer;
}

.save {
  /* flex: 1;
  height: 66px;
  line-height: 66px;
  border-radius: 66px;
  border: 1px solid #3a60ff;
  background: #3a60ff;
  font-size: 34px;
  color: #ffffff;
  font-weight: 600;
  text-align: center;
  margin-left: 20px; */
  width: 134px;
  height: 46.5px;
  line-height: 46.5px;
  color: #fff;
  background-color: #3a60ff;
  border: 1px solid #3a60ff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 25px;
  text-align: center;
  cursor: pointer;
}

.safe-div {
  width: 100%;
  height: constant(safe-area-inset-bottom);
  height: env(safe-area-inset-bottom);
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10;
  background-color: #ffffff;
}

.tab-active {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  /* margin-left: 24px; */
  cursor: pointer;

  p {
    font-size: 19px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: left;
    color: #323b5a;
    line-height: 20px;
    text-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.18);
    margin-top: 20px;
  }

  span {
    display: block;
    width: 23px;
    height: 4px;
    background: #1877ff;
    border-radius: 2px;
    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.18);
  }
}

.tab-inactive {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  /* margin-left: 24px; */
  cursor: pointer;

  p {
    font-size: 19px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: Medium;
    text-align: left;
    color: #a7adc6;
    line-height: 20px;
    text-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.18);
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionStartAndEnd/QuestionStartAndEnd.vue